export const environment: any = {
    production: false,
	env: 'us-int',
	appConfig: {
		"isDev": false,
		"isTest": true,
		'env': 'us-int',
		'envType': 'int',
		"title": "Tabit Pay US-INT",
		"region": "US",
        'countryCode': 'US',
        'currencyCode': 'USD',
		"host": "https://us-pay.tabit-int.com",
		"tabitAPI": "https://us-int-ros.tabit-stage.com",
		"logsAPI": "https://us-logzp.tabit-int.com/logz/?type=tabitPay",
		"tabitBridge": "https://us-bridge.tabit-int.com",
		"tabitBillURL": 'https://us-int-documents.tabit-stage.com',
		"tdURL": "https://us-int-tabitorder.tabit-stage.com",
		"stripeClientKey": "pk_test_51M2Zf9CwcLVxIMhaQwjBw183FsOqh8ao4JRF6RUgqqEOu2zYktPKscmeNKujqPxWR4rKlBSCXeTpDpzi26mmjppr002NCnO7YM",
		"tabitLoyaltyAPI": "https://tabitloyaltyapi-dev.azurewebsites.net/api",
		"tabitDefaultOrganizationId": "53eb1ee2e6c77111203d8501",
		"loyaltyJoinChannelGUID": "CDA3B904-5FB5-472B-97D4-52B966F167A5",
		"tabitClientID": "urfoxj8ymmz2bbfolofq4xsjr9psc3q7ii76b2n3",
		"loyaltyEnv": "us",
		"accessibilityDeclaration": "https://s3.eu-west-1.amazonaws.com/files.tabit.cloud/tabit-app/general-app/accessibility-statement.pdf",
		"authorizeNetURL": "https://test.authorize.net/payment/payment",
		'gAnalyticsKey': null,
		"recaptchaSiteKey": "6LeDiWknAAAAABrgMGkCN4IADXdZo0ZjAcLh16gU",
		"apmServer": "https://c8783b894a2c41668ca2d7233e7bd375.apm.eu-west-1.aws.cloud.es.io:443",
		"mixpanelProjectToken": "de7f78244fad011cdffa957f610c28de",
		"includeScripts": []
    }
};
